<template>
  <div role="search" class="home-market-select">
    <form @submit.prevent="submit">
      <strong aria-label="Postleitzahl Eingabe" aria-controls="plzInput" class="title desktop" v-if="!market"
        >Postleitzahl Eingabe</strong
      >
      <strong class="title" v-else>Ausgewählter REWE Markt</strong>

      <div class="select-input desktop" v-if="!market">
        <input
          aria-label="Postleitzahl Eingabe"
          id="plzInput"
          type="text"
          maxlength="5"
          max="99999"
          value=""
          name="plz"
          autocomplete="postal-code"
          :placeholder="51063"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model="zip"
          @keypress="onlyNumber"
          :class="{ error: error }"
          ref="input"
          data-mf-replace="**REMOVED**"
          tabindex="16"
        >
        <button type="submit" class="button-primary" v-on:click.prevent="submit" tabindex="17" aria-label="Markt suchen">
          <span class="desktop">Markt suchen</span>
          <i class="icon-search mobile" aria-hidden="true"></i>
        </button>
      </div>

      <div class="select-input-mobile mobile" v-if="!market">
        <div class="input" v-on:click.prevent="submitMobile">
          PLZ eingeben
        </div>
        <button class="button-primary" v-on:click.prevent="submitMobile">
          <span>Markt suchen</span>
          <i class="icon-search mobile" aria-hidden="true"></i>
        </button>
      </div>

      <span class="error" v-if="error" aria-live="polite">
        Die Postleitzahl scheint leider ungültig zu sein.
      </span>
      <div v-if="market" class="market-box">
        <span>
          {{ market.address.street }}<br />
          {{ market.address.zip }} {{ market.address.city }}
        </span>
        <button v-on:click.prevent="resetMarket" aria-label="Markt löschen" tabindex="18">
          <img src="/assets/images/close-icon.png" alt="Markt löschen">
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "home-market-select",
  data() {
    return {
      error: false
    };
  },
  methods: {
    resetMarket() {
      this.$store.commit("SET_ZIP", null);
      this.$store.commit("SET_MARKET", false);
      this.$store.dispatch("updateShoppinglistData");
      this.$router.replace({ name: "home" });
    },
    submitMobile() {
      this.$store.commit("SET_ZIP", null);
      this.$store.commit("SET_MARKET", false);
      this.$store.dispatch("updateShoppinglistData");
      this.$emit("showMarketSearchMobile");
    },
    submit() {
      this.error = false;
      if (!this.zip || this.zip.length < 5) {
        this.error = true;
        this.$refs.input.select();
        return false;
      }
      // this.$trackCustomEvent('click_feuerwerk2025_marktsuche');
      this.$emit("showMarketSearchResults");
    },
    onlyNumber(evt) {
      this.error = false;
      if (evt.keyCode == 13) {
        // "Return"
        this.submit();
        return false;
      }
      if (evt.keyCode >= 48 && evt.keyCode <= 57) {
        // 0, 1, 2, ... 9
        return true;
      }
      evt.preventDefault();
    }
  },

  computed: {
    ...mapState(["loading", "market"]),
    ...mapGetters(["isMobile"]),
    zip: {
      get() {
        return this.$store.state.zip;
      },
      set(val) {
        this.$store.commit("SET_ZIP", val);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./HomeMarketSelect";
</style>
